<script>
import FormSelectSingle from "./FormSelectSingle.vue";
import FormText from "./FormText.vue";
import FormPhotos from "./FormPhotos.vue";
import FormDate from "./FormDate.vue";
import FormRange from "./FormRange.vue";
import FormTextLong from "./FormTextLong.vue";

const formComponents = {
  select_single: FormSelectSingle,
  text: FormText,
  photos: FormPhotos,
  range: FormRange,
  date: FormDate,
  text_long: FormTextLong
};

export default {
  props: ["component", "value"],
  render(h) {
    const formComponent = formComponents[this.component.type];
    if (formComponent) {
      const properties = this.component.properties || {};
      return h(formComponent, {
        props: { value: this.value, properties },
        on: {
          input: value => {
            this.$emit("input", value);
          },
          next: () => {
            this.$emit("next");
          }
        }
      });
    }
    return h();
  }
};
</script>
